import Cookies from 'js-cookie'

const cookieOptions = { expires: 70000, path: '/' }

export function setToken(value) {
    return Cookies.set("token", value, cookieOptions);
}
export function getToken() {
    return Cookies.get("token");
}
export function removeToken() {
    return Cookies.remove("token", { path: '/' });
}
export function setRefreshToken(value) {
    return Cookies.set("refreshToken", value, cookieOptions);
}
export function getRefreshToken() {
    return Cookies.get("refreshToken");
}
export function removeRefreshToken() {
    return Cookies.remove("refreshToken", { path: '/' });
}
export function setUrl(value) {
    return window.sessionStorage.setItem("baseUrl", value)
}
export function getUrl() {
    return window.sessionStorage.getItem("baseUrl")
}
export function setNotice(value) {
    return Cookies.set("notice", value, { expires: 90, path: '/' });
}
export function getNotice() {
    return Cookies.get("notice");
}
export function removeNotice() {
    return Cookies.remove("notice", { path: '/' });
}
/**
 * 清除所有登录相关的 cookie
 */
export function removeAllAuthCookies() {
    removeToken();
    removeRefreshToken();
    removeNotice();
}